export default "__VITE_ASSET__D7WNLq4z__"